import styled from 'styled-components';
import { DashboardCardContainer, DashboardCardScrollContainer } from '../styles';

// goal section
export const GoalCardContainer = styled(DashboardCardContainer)``;
export const GoalCardScrollContainer = styled(DashboardCardScrollContainer)``;
